import { getColorFromString, IColor, updateA } from '@fluentui/react';

export function throwOnUndefinedColor(
    desiredColor: string | undefined,
    desiredColorName: string,
    callingComponentName: string
  ): string {
    if (!desiredColor) {
      throw new Error(
        `M365Theme error: It looks like the app tried to reference a theme color that didn't exist.\n
        Double check you're consuming a M365Theme (a super set of Fabric ITheme) and that it has assinged the extension slot.\n
        Undefined extension slot: ${desiredColorName}\n
        Calling component: ${callingComponentName}\n
        'For more information, please visit https://uifabric.visualstudio.com/iss/_git/m365-admin/?path=%2Fdocs%2Ftheming.md&version=GBmaster';
  
  `
      );
    }

    return desiredColor;
}

/**
 * Converts a hex color to an rgba value. This is useful when
 * we want to change the opacity of a theme color, which come
 * as hex. Note that IE and Edge don't yet support 8 digit
 * hex values so you'll need to use this any time you're trying to
 * change the opacity of a theme color
 *
 * @param hexColor The original 6 digit hex value
 * @param alphaValue The alpha value you'd like to assign, ie: 20 for 20%
 *  */
export function addAlphaChannelToHex(hexColor: string, alphaValue: number): string {
  const fabricColor: IColor | undefined = getColorFromString(hexColor);

  if (fabricColor) {
    return updateA(fabricColor, alphaValue).str;
  }

  return hexColor;
}
